

import * as _ from 'lodash'
const AdminRoles = ['urn:rdl:epm-std:project_manager', 'urn:rdl:epm-std:project_admin'];

const defaultFeatureSet = {
    groups:{
        "ALL": { 
            /* the same as the default group
            state: undefined | "show" | "hide" | "disable"
            roles: undefined | ["role1", "role2", ...] //apply the state for these roles. undefined value means to apply for all roles
            */
            default: { //
                state: "hide", //undefined | "show" | "hide" | "disable"
                role: undefined, // undefined | ["role1", "role2", ...] //apply the state for these roles. undefined value means to apply for all roles
            }, 
            override: {
                state: undefined, //undefined | "show" | "hide" | "disable"
                role: undefined, // ["role1", "role2", ...] //apply the state for these roles. undefined value means to apply for all roles
            }
        },
    
        "Header": {state: 'show'},
        "Change": {},
        "Project": {},
        "Definition": {},
        "Catalogues": {},
        "Baseline": {},
        "Issues": {},
        "Messages": {},
        "Import": {state: 'show'},
        "Export": {state: 'show'},
        "Search": { state: 'show'},
        "Document": {},
        "Product": {},
        "DomainManagment": { state: 'show' },
    },
    
    items:{
        /*
            "NameItems": {
                state: undefined | "show" | "hide" | "disable", // undefined is equal to 'show'
                roles: undefined | ['Role1', 'Role2', ...], //apply the state for these roles. undefined value means to apply for all roles
                groups: undefined | ['GroupName1', 'GroupName2', ...], // undefined = ['ALL'], for the list of groups always will be inserted the 'ALL' group on the first place.
            }
        */
        "Logo": { state: 'show', groups:["Header"] },
        "AppName": { state: 'show', groups:["Header"] },
        "Account": {state: 'show', groups:["Header"] },
        "Logout": {state: 'show', groups:["Header"] },
        "Help": { state: "show", groups:["Header"]},
        "LanguageSwitch": { state: 'show', groups:["Header"] },

        "Messages.View": {state: 'show', groups:["Messages", "Header"]},
        "Messages.Send": {state: 'show', groups:["Messages", "Header"]},
        "DownloadByHASH":{ state: 'show', groups:["Header"] },

        "Comparison.View": { state: "show" },
        "Blockchain.View": { state: "show", role:AdminRoles },

        "Breadcrumps": { state: "show" },
        "Help2": { state: "hide"},
        "LanguageSwitch2": { state: 'hide' },
        
        "Project.Select": { state: 'show', groups: ["Project"] },
        "Project.CreateFolder": { state: 'show', groups: ["Change", "Project"] },
        "Project.Create": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNew": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNewFromPDM": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNewFromText": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNewFromBaseline": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNewFromAP242": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNewFromASDDEX1": { state: 'show', groups: ["Change", "Project"] },
        "Project.ImportNewFromZipSys": { state: 'show', groups: ["Change", "Project"] },
        "Project.MoveToFolder": { state: 'show', groups: ["Change", "Project"] },
        "Project.SetInactive": { state: 'show', groups: ["Change", "Project"], role:[...AdminRoles] },

        "Project.Definition.View": { state: 'show', groups: ["Project", "Definition"], role:[...AdminRoles, 'urn:rdl:epm-std:rdl_manager']},
        "Project.Definition.Edit": { state: 'show', groups: ["Change", "Project", "Definition"], role:[...AdminRoles, 'urn:rdl:epm-std:rdl_manager']},
        "Project.Catalogues.View": { state: 'show', groups: ["Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Edit": { state: 'show', groups: ["Change", "Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Organizations.View": { state: 'show', groups: ["Project", "Catalogues"], role:AdminRoles},
        "Project.Catalogues.Organizations.Edit": { state: 'show', groups: ["Change", "Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Products.View": { state: 'show', groups: ["Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Products.Edit": { state: 'show', groups: ["Change", "Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Actions.View": { state: 'show', groups: ["Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Actions.Edit": { state: 'show', groups: ["Change", "Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Triggers.View": { state: 'show', groups: ["Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.Triggers.Edit": { state: 'show', groups: ["Change", "Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.NotificatinTasks.View": { state: 'show', groups: ["Project", "Catalogues"], role:AdminRoles },
        "Project.Catalogues.NotificatinTasks.Edit": { state: 'show', groups: ["Change", "Project", "Catalogues"], role:AdminRoles },

        "Project.Baseline.View": { state: 'show', groups: ["Project", "Baseline"] },
        "Project.Baseline.Export": { state: 'show', groups: ["Project", "Baseline"] },
        "Project.Baseline.Delete": { state: 'show', groups: ["Change", "Project", "Baseline"] },
        "Project.Baseline.Approval": { state: 'show', groups: ["Change", "Project", "Baseline"] },
        "Project.Baseline.Create": { state: 'show', groups: ["Change", "Project", "Baseline"] },

        "Project.Issues.View": { state: 'show', groups: ["Project", "Issues"] },
        "Project.Issues.Create": { state: 'show', groups: ["Change", "Project", "Issues"] },
        "Project.Issues.Edit": { state: 'show', groups: ["Change", "Project", "Issues"] },
        
        "Search.QuickNode": { state: "show", groups: ["Search"] },
        "Search.Node": { state: "show", groups: ["Search"] },
        "Search.QuickDoc": { state: "show", groups: ["Search"] },
        "Search.Doc": { state: "show", groups: ["Search"] },
        "Search.DocByContent": { state: "show", groups: ["Search"] },

        "RootNode.ImportCSV": { state: 'show', groups: ["Change", "Import"] },
        "RootNode.Edit": { state: 'show', groups: ["Change"] },
        "RootNode.EditVersion": { state: 'show', groups: ["Change"], role:AdminRoles },
        "RootNode.SelectVersion": { state: 'show' },
        "RootNode.SetPhase": { state: 'show', groups: ["Change"], role:AdminRoles },
        "RootNode.LockProject": { state: 'show', groups: ["Change"], role:AdminRoles },
        "RootNode.Validate": { state: 'show', role:AdminRoles },
        "RootNode.ExportToFile": { state: 'show', role:AdminRoles, groups: ["Export"] },
        "RootNode.ExportToTxt": { state: 'show', role:AdminRoles, groups: ["Export"] },
        "RootNode.ExportToDEX": { state: 'show', role:AdminRoles, groups: ["Export"] },
        "RootNode.ExportToAP242": { state: 'show', role:AdminRoles, groups: ["Export"] },

        "Node.Create": { state: "show", groups: ["Change"] },
        "Node.Edit": { state: "show", groups: ["Change"] },
        "Node.Properties.View": { state: "show" },
        "Node.Properties.ColumnNum": { state: "hide" },
        "Node.Properties.ColumnType": { state: "hide" },
        "Node.Properties.ColumnAction": { state: "show" },
        "Node.UserProperties.View": { state: "show" },
        "Node.UserProperties.Edit": { state: "show", groups: ["Change"] },
        "Node.UserProperties.ColumnNum": { state: "show" },
        "Node.UserProperties.ColumnType": { state: "show" },
        "Node.UserProperties.ColumnAction": { state: "show" },
        "Node.Delete": { state: "show", groups: ["Change"] },
        "Node.CopyPaste": { state: "show", groups: ["Change"] },
        "Node.ShowInContext": { state: "show" },
        "Node.ShowInTree": { state: "show" },
        "Node.ShowInGraph": { state: "show" },

        "Node.AddOrganization": { state: "show", groups: ["Change"] },
        "Node.AddProduct": { state: "show", groups: ["Change"] },
        "Node.AddRequirement": { state: "show", groups: ["Change"] },
        "Node.GenerateDocument": { state: "show", groups: ["Change"] },
        "Node.AddDataFile": { state: "show", groups: ["Change"] },
        "Node.CopyPasteFile": { state: "show", groups: ["Change"] },

        "Node.ViewChangeLog": { state: "show" },
        "Node.ImportPDM": { state: "show", groups: ["Change", "Import"] },
        "Node.ImportAP242": { state: "show", groups: ["Change", "Import"] },
        "Node.ImportReqIF": { state: "show", groups: ["Change", "Import"] },
        "Node.ImportText": { state: "show", groups: ["Change", "Import"] },
        "Node.ImportZipFolder": { state: "show", groups: ["Change", "Import"] },
        "Node.ImportProject": { state: "show", groups: ["Change", "Import"] },
        "Node.ExportZipFolder": { state: "show", groups: ["Export"]},
        "Node.ExportPDM": { state: "show", groups: ["Export"]},
        "Node.ExportAP242": { state: "show", groups: ["Export"]},

        "Node.DomainManagment.View": {state: "show", groups: ["DomainManagment"] },
        "Node.DomainManagment.Create": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Delete": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Members.View": {state: "show", groups: ["DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Members.Edit": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Members.Create": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Members.Delete": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Role.View": {state: "show", groups: ["DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Role.Create": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Role.Edit": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },
        "Node.DomainManagment.Role.Delete": {state: "show", groups: ["Change", "DomainManagment"], role:[...AdminRoles, 'urn:rdl:epm-std:project_leader'] },

        "Nodes.Sort": { state: "show" },
        "Nodes.ShowOccurrences": { state: "show" },
        "Nodes.ShowShapes": { state: "show" },
        "Nodes.ShowChildOccurrences": { state: "show" },

        "Document.Edit": { state: "show", groups: ["Change", "Document"] },
        "Document.Checkout": { state: "show", groups: ["Change", "Document"] },
        "Document.UndoCheckout": { state: "show", groups: ["Change", "Document"] },
        "Document.Checkin": { state: "show", groups: ["Change", "Document"] },
        "Document.Delete": { state: "show", groups: ["Change", "Document"] },
        "Document.SetReadonly": { state: "show", groups: ["Change", "Document"] },
        "Document.Convert2WCAX": { state: "show", groups: ["Change", "Document"] },
        "Document.ConvertToPDF": { state: "show", groups: ["Change", "Document"] },
        "Document.Open": { state: "show", groups: ["Document"] },
        "Document.Download": { state: "show", groups: ["Document"] },
        "Document.ViewHistory": { state: "show", groups: ["Document"] },
        "Document.Notes.View": { state: "show", groups: ["Document"] },
        "Document.Notes.Create": { state: "show", groups: ["Change", "Document"] },
        "Document.Dependencies.View": { state: "show", groups: ["Document"] },
        "Document.Dependencies.Create": { state: "show", groups: ["Change", "Document"] },
        "Document.Properties.View": { state: "show", groups: ["Document"] },
        "Document.Properties.ColumnNum": { state: "hide" },
        "Document.Properties.ColumnType": { state: "hide" },
        "Document.Properties.ColumnAction": { state: "show" },
        "Document.UserProperties.View": { state: "show", groups: ["Document"] },
        "Document.UserProperties.Edit": { state: "show", groups: ["Change", "Document"] },
        "Document.UserProperties.ColumnNum": { state: "show" },
        "Document.UserProperties.ColumnType": { state: "show" },
        "Document.UserProperties.ColumnAction": { state: "show" },

        "Product.Create": { state: "show", groups: ["Change", "Product"] },
        "Product.Edit": { state: "show", groups: ["Change", "Product"] },
        "Product.Delete": { state: "show", groups: ["Change", "Product"] },
        "Product.Properties.View": { state: "show", groups: ["Product"] },
        "Product.UserProperties.View": { state: "show", groups: ["Product"] },
        "Product.UserProperties.Edit": { state: "show", groups: ["Change", "Product"] },
    },
    initial_config: {
        searchResultsPanelHeight: 30,
        elementsListPanelWidth: 28,
        toolsPanelWidth: 15,
        propertiesPanelWidth: 57,
        systemPropertiesPanelHeight: 40
    }
}

const FeaturesSet = {
    cache: {},
    currentRoles: [],
    currentFeatureSet: defaultFeatureSet,
    persistStore: null,
    commonContext: undefined,

    init(set, persistStore, commonContext){
        this.currentFeatureSet = _.merge(_.cloneDeep(defaultFeatureSet), set);
        console.log('currentFeatureSet', this.currentFeatureSet);
        this.cache = {};
        this.persistStore = persistStore || {
            nonPersitStore: {},
            getItem(key){ return this.nonPersitStore[key]; },
            setItem(key, value){ this.nonPersitStore[key] = value;}
        }
        this.commonContext=commonContext && commonContext+'-';
    },
    setRoles(roles){
        this.currentRoles = roles;
    },

    calcState(item, groups, roles) {
        const isRolesIntersection = (roles1, roles2) => {
            return roles1.some(r1 => roles2.includes(r1));
        }

        const overrideState = groups.reduceRight((result, grp)=> {
            const iRoles = grp.override?.role;
            if (iRoles && roles?.length && !isRolesIntersection(iRoles, roles)) return result;
            return grp.override?.state || result;
        }, undefined);

        if (overrideState) return overrideState;

        const state = (item.role?.length && roles?.length && !isRolesIntersection(item.role, roles)) ? undefined : item.state;
        if (state) return state;

        const defaultState = groups.reduce((result, grp)=> {
            const iRoles = grp.default?.role || grp.role;
            if (iRoles && roles?.length && !isRolesIntersection(iRoles, roles)) return result;
            return (grp.default?.state || grp.state) || result;
        }, undefined);

        return defaultState;
    },

    getState(itemId, roleOverride){
        const roles = roleOverride || this.currentRoles;
        
        if (!this.cache[roles]) this.cache[roles] = {};
        if (this.cache[roles][itemId]) return this.cache[roles][itemId];

        let item = this.currentFeatureSet.items[itemId];
        if (!item) item = (this.currentFeatureSet.groups[itemId] 
            ? {...this.currentFeatureSet.groups[itemId], groups:[itemId]} 
            : this.currentFeatureSet.groups['ALL']);
        if (!item) return undefined;
        let itemGroups = ["ALL", ...(item.groups || [])];
        let state = this.calcState(item, itemGroups.map(gName => this.currentFeatureSet.groups[gName]).filter(g=>g), roles);
        //console.log("Result for " + itemId + " state:"+state);
        this.cache[roles][itemId] = state;
        return state;
    },

    show(itemId, roleOverride){
        let state = this.getState(itemId, roleOverride);
        return state !== 'hide';
    },
    
    disabled(itemId, roleOverride){
        let state = this.getState(itemId, roleOverride);
        return state === 'disable';
    },

    getInitialValue(itemId){
        return this.currentFeatureSet.initial_config?.[itemId];
    },
    getKey(itemId, context){
        return `${this.commonContext || 'common-'}${context?(context+'-'):''}${itemId}`;
    },
    configValue(itemId, context) {
        let val = this.persistStore?.getItem(this.getKey(itemId, context));
        if (val !== null){
            try{
                val = JSON.parse(val);
            }catch(e){ /* do nothing */ }
            return val;
        }
        return this.getInitialValue(itemId)
    },
    saveConfigValue(itemId, value, context) {
        this.persistStore?.setItem(this.getKey(itemId, context), JSON.stringify(value));
    }
}
export default FeaturesSet;
